import { Component, OnInit } from '@angular/core';
import { GDSCodeService } from 'app/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-rate-avail',
  templateUrl: './rate-avail.component.html',
  styleUrls: ['./rate-avail.component.scss']
})
export class RateAvailComponent implements OnInit {

  private auditId:string;
  private scheduleId:string;
  constructor(
    private gdsCodeService:GDSCodeService,
    private route: ActivatedRoute) {
    //get parameters of child component
    let children = this.route.children;
    if(children && children.length>=1) {
      this.auditId = (<any>children[0].params).value.auditId;
      this.scheduleId = (<any>children[0].params).value.scheduleId;
      gdsCodeService.storeGDSCodeList(this.auditId, this.scheduleId);
    }
  }

  ngOnInit() {
  }

}
